import { api } from "../api";
import type { PaginatedResponse } from "@/types/common";

/** Mirrors the backend `AuditLogEntry` (audit-logs.service.ts). */
export interface ActivityLogEntry {
  id: number;
  action: string;
  entityType: string;
  entityId: number | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  actor: { id: number; name: string; email: string } | null;
}

export interface ActivityLogParams {
  page?: number;
  limit?: number;
  search?: string;
  /** Honored only for org-wide readers (audit:read); otherwise scoped to self. */
  userId?: number;
  entityType?: string;
  entityId?: number;
  action?: string;
  /** ISO date bounds. */
  from?: string;
  to?: string;
}

export const activityApi = {
  paginate: (params?: ActivityLogParams): Promise<PaginatedResponse<ActivityLogEntry>> => {
    const query = new URLSearchParams();
    if (params?.page) query.set("page", String(params.page));
    if (params?.limit) query.set("limit", String(params.limit));
    if (params?.search) query.set("search", params.search);
    if (params?.userId) query.set("userId", String(params.userId));
    if (params?.entityType) query.set("entityType", params.entityType);
    if (params?.entityId) query.set("entityId", String(params.entityId));
    if (params?.action) query.set("action", params.action);
    if (params?.from) query.set("from", params.from);
    if (params?.to) query.set("to", params.to);

    const qs = query.toString();
    return api.get<PaginatedResponse<ActivityLogEntry>>(
      qs ? `/audit-logs?${qs}` : "/audit-logs",
    );
  },
};
